import type { FaireProductEntity } from "../../entity_types/product";

export const p_a40ogv4t8l: FaireProductEntity = {
  token: "p_a40ogv4t8l",
  type: "product",
  name: "Rainbow Head Greeting Card",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/fdc0b2e819429d4c0cd33f5bb2af6af358aaa9b4452e3b544129eb2447dd5746.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/025eb5c744492bc97cd9876ef381f064d20614b00e8ef5e8126a1b4d33d964e5.webp",
    "https://cdn.faire.com/fastly/80238f44183a86fc3c93c48a848c2bb44cfa97a575cf34ce7a2eaa63036155f7.png",
  ],
  priceDollars: 3,
  description:
    "At E. Frances, we believe connection makes the world better. And happier! Our original artwork paired with just-right words warms the heart and helps make meaningful connections easier. Every card begins with a lovingly painted watercolor, and is then printed on luxurious heavyweight paper with brilliant color and, when featured, metallic foil accents.\n\nAnd because we think tiny details can make a big impact, you’ll always find a second illustration on the back of every card!",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:37:23.771Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
